// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3v5tw","dragIcon":"Choice_dragIcon__24nAd","left":"Choice_left__3SGCA","input":"Choice_input__1y7S9"};